import { motion } from "framer-motion";
import iconImg from "@assets/images/white-icon-list.avif";
import { MdOutlineDoubleArrow } from "react-icons/md";

function Card({ index,  heading, text, colorScheme,img }){
    return(
      <div 
      
       key={index}
      className="transition-all duration-300 ease-in hover:bg[#FFC067] cursor-pointer drop-shadow-xl h-full   rounded-lg  items-center overflow-hidden  w-full md:w-[calc(49%-0.67rem)] xl:w-[calc(32%-0.67rem)] "
    >
      {/* <div  
        className={`flex justify-center items-center space-x-3 py-5 md:py-0 md:min-h-20 lg:min-h-20  px-5 bg-[#6D1349]`}

      >  */}
      <div  
        className={`flex justify-start items-center space-x-3 py-5 md:py-0 md:min-h-20 lg:min-h-20  px-5 ${img? 'bg-[#f3ebfa]':'bg-[#6D1349]'}`}

      > 
                  <img src={ img ?img :iconImg} alt='List icon' className="w-8 object-contain " width={10} height={10}/>
      {/* <MdOutlineDoubleArrow  className="text-primary text-4xl"/> */}

         
        <motion.h3
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true, amount: 0.3 }}
          className={`text-[18px] lg:text-[20px] xl:text-[22px]    font-bold   whitespace-pre-line ${img? 'text-dark':'text-white'}`}
        >
          {heading}  
        </motion.h3>
      </div>
      <div className="px-5 py-5 bg-white "> 
        <p className="text-base leading-[1.625rem] text-dark">{text}</p>
      </div>
    </div>
    )
}

export default Card;